import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { Button, Radio, Input, message } from "antd";
import { CLIENT_CREE_RESET } from "../constantes/clientsConstantes";
import { clientInscription } from "../actions/clientsActions";
import { Select } from "antd";
import { listeGroup } from "../actions/groupActions";
import "../AjoutClient.css";
import { UploadOutlined, CheckOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import TextZone from "../TextZone";
import { creeInscription } from "../actions/inscriptionActions";
import { store } from "../store";
import { INSCRIPTION_CREE_RESET } from "../constantes/inscriptionConstantes";
import cardid from "../assets/cardid.png";
import patentenv from "../assets/patentenv.png";
import { useNavigate } from "react-router-dom";
const { Option } = Select;

let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();

const AjoutClient = () => {
  const dispatch = useDispatch();
  const [photo_cin, setPhoto_cin] = useState(null);
  const [photoCinObj, setPhotoCinObj] = useState(null);
  const [photo_patente, setPhoto_patente] = useState(null);
  const [photoPatObj, setPhotoPatObj] = useState(null);
  const [nom_cli, setNomCli] = useState("");
  const [pren_cli, setPrenCli] = useState("");
  const [nom_soc, setNomSoc] = useState("");
  const [adr_cli, setAdrCli] = useState("");
  const [tel_cli, setTelCli] = useState("");
  const [activite, setAct] = useState("");
  const [cin, setCin] = useState(0);
  const [mat_fisc, setMat] = useState("");
  const [loadImg, setLoadImg] = useState(false);
  const [mat1, setMat1] = useState("000");
  const [mat2, setMat2] = useState("");
  const [mat3, setMat3] = useState(0);
  const [mat4, setMat4] = useState("");
  const [compressCin, setCompressCin] = useState(null);
  const [compressPat, setCompressPat] = useState(null);
  const [focus, setFocus] = useState(false);
  const ICree = useSelector((state) => state.inscCree);
  const { erreur, loading, inscription } = ICree;
  const [tabAct] = useState([
    { _id: "1", value: "عطار" },
    { _id: "2", value: "مغازة" },
    { _id: "4", value: "حماص" },
    { _id: "5", value: "دبو" },
    { _id: "6", value: "ســوبارات" },
    { _id: "7", value: "مـــزرعـــة" },
    { _id: "8", value: "مـــرطبات" },
    { _id: "9", value: "مطعم" },
    { _id: "10", value: "مؤسسة" },
    { _id: "11", value: "بيع خضر و غلال" },
    { _id: "12", value: "بيع عطورات" },
  ]);
  const navigate = useNavigate();
  const pickImage = async (type) => {
    try {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";

      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (file) {
          if (type === "cin") {
            setPhotoCinObj(file);
            setPhoto_cin(URL.createObjectURL(file));
          } else {
            setPhotoPatObj(file);
            setPhoto_patente(URL.createObjectURL(file));
          }
        }
      };
      input.click();
    } catch (error) {
      message.error(error.message);
    }
  };

  const createFormData = (type) => {
    let formData = new FormData();
    const file = type === "cin" ? photoCinObj : photoPatObj;

    if (file) {
      formData.append("file", file);
    }
    return formData;
  };

  const handleUploadPhotoCin = async () => {
    setLoadImg(true);
    if (!photoCinObj) {
      setLoadImg(false);
      return "/uploads/img_default.png";
    }

    try {
      const formData = new FormData();
      formData.append("file", photoCinObj); // Make sure this matches your backend expectation

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          // Add any auth headers if needed
        },
      };

      const { data } = await axios.post(
        `${uri}/api/uploadSftp`,
        formData,
        config
      );
      setLoadImg(false);
      return data;
    } catch (error) {
      setLoadImg(false);
      message.error("Failed to upload CIN image");
      console.error("Upload error:", error);
      return "/uploads/img_default.png";
    }
  };

  const handleUploadPhotoPatente = async () => {
    setLoadImg(true);
    if (!photoPatObj) {
      setLoadImg(false);
      return "/uploads/img_default.png";
    }

    try {
      const formData = new FormData();
      formData.append("file", photoPatObj); // Make sure this matches your backend expectation

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          // Add any auth headers if needed
        },
      };

      const { data } = await axios.post(
        `${uri}/api/uploadSftp`,
        formData,
        config
      );
      setLoadImg(false);
      return data;
    } catch (error) {
      setLoadImg(false);
      message.error("Failed to upload Patente image");
      console.error("Upload error:", error);
      return "/uploads/img_default.png";
    }
  };

  useEffect(() => {
    if (inscription === undefined) {
      remiseZero("non");
    } else {
      remiseZero("oui");
    }
  }, [inscription]);

  const submitHandler = async () => {
    if (
      nom_cli == "" ||
      pren_cli == "" ||
      nom_soc == "" ||
      tel_cli.length != 8 ||
      adr_cli == "" ||
      activite == ""
    ) {
      message.error("الرجاء ادخال جميع المعطيات");
    } else {
      let imgCin = await handleUploadPhotoCin();
      let imgPat = await handleUploadPhotoPatente();
      await dispatch(
        creeInscription({
          nom_cli,
          pren_cli,
          nom_soc,
          adr_cli,
          cin_cli: cin,
          mat_fisc: mat3 + mat2 + mat1,
          activite,
          tel_cli,
          photo_cin: imgCin,
          photo_patente: imgPat,
        })
      );
    }
  };

  const remiseZero = (etatSauv) => {
    if (etatSauv == "oui") {
      setNomCli("");
      setPrenCli("");
      setAdrCli("");
      setNomSoc("");
      setTelCli(0);
      setCin(0);
      setMat3(0);
      setMat2("");
      setAct("");
      setPhotoCinObj(null);
      setPhotoPatObj(null);
      setPhoto_cin(null);
      setPhoto_patente(null);
    }
  };

  return (
    <div className="ajout-client-container">
      <div className="ajout-client-form-container">
        <TextZone
          titre={"اســـم المستعمل"}
          value={nom_cli}
          onEdit={(txt) => setNomCli(txt)}
          attention={nom_cli == "" && "الرجاء ادخال المستعمل"}
        />

        <TextZone
          titre={"اللقــــب"}
          value={pren_cli}
          onEdit={(txt) => setPrenCli(txt)}
          attention={pren_cli == "" && "الرجاء ادخال اللقب"}
        />

        <TextZone
          titre={"الأســم الأجتــــماعي"}
          value={nom_soc}
          onEdit={(txt) => setNomSoc(txt)}
          attention={nom_soc == "" && "الرجاء ادخال الأســم الأجتــــماعي"}
        />

        <TextZone
          titre="رقم الـــهاتف"
          value={tel_cli}
          onEdit={(txt) => setTelCli(txt)}
          keyboardType="numeric"
          maxLength={8}
          attention={
            (tel_cli == 0 || tel_cli.length != 8) &&
            "الرجاء ادخال  رقم الـــهاتف"
          }
        />

        <TextZone
          titre="رقم بطاقة الهوية"
          value={cin}
          onEdit={(txt) => setCin(txt)}
          keyboardType="numeric"
        />

        <div className="ajout-client-field-container">
          <div className="ajout-client-field-title">
            رمــــز الــــباتينـــدة
          </div>
          <div className="ajout-client-mat-fisc-container">
            <Input
              className="ajout-client-mat-input"
              value={mat3}
              placeholder="1234567"
              type="number"
              maxLength={7}
              onChange={(e) => setMat3(e.target.value)}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
            />
            <Input
              className="ajout-client-mat-input"
              value={mat2}
              placeholder=""
              onChange={(e) => setMat2(e.target.value.toUpperCase())}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              maxLength={3}
            />
            <Input
              className="ajout-client-mat-input"
              value={mat1}
              placeholder="mat1"
              onChange={(e) => setMat1(e.target.value)}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              maxLength={3}
            />
          </div>
          {(mat3 == "" || mat3.length != 7 || mat2 == "") && (
            <div className="ajout-client-error-text">
              الرجاء ادخال رقم بطاقة الهوية
            </div>
          )}
        </div>

        <TextZone
          titre="الـــعنوان"
          value={adr_cli}
          onEdit={(txt) => setAdrCli(txt)}
          attention={adr_cli == "" && "الرجاء ادخال  الـــعنوان"}
        />

        <div className="ajout-client-field-container">
          <div className="ajout-client-field-title">النشاط</div>
          <Select
            placeholder="اختر النشاط"
            className="ajout-client-select"
            value={activite || undefined}
            onChange={(value) => setAct(value)}
          >
            {tabAct.map((item) => (
              <Option key={item._id} value={item.value}>
                {item.value}
              </Option>
            ))}
          </Select>
          {activite == "" && (
            <div className="ajout-client-error-text">الرجاء ادخال النشاط</div>
          )}
        </div>

        <div className="ajout-client-image-upload-container">
          <div
            className="ajout-client-image-upload"
            onClick={() => !(loadImg || loading) && pickImage("cin")}
          >
            <img
              src={photo_cin || cardid}
              className="ajout-client-upload-image"
              alt="CIN"
            />
            {photo_cin ? (
              <FontAwesomeIcon icon={faCheck} color="green" />
            ) : (
              <div className="ajout-client-upload-text">صورة الهوية</div>
            )}
          </div>

          <div
            className="ajout-client-image-upload"
            onClick={() => !(loadImg || loading) && pickImage("pat")}
          >
            <img
              src={photo_patente || patentenv}
              className="ajout-client-upload-image"
              alt="Patente"
            />
            {photo_patente ? (
              <FontAwesomeIcon icon={faCheck} color="green" />
            ) : (
              <div className="ajout-client-upload-text">
                صورة من الــباتيندة
              </div>
            )}
          </div>
        </div>

        {loading || loadImg ? (
          <div className="loading-overlay">
            <div className="loading-text">Veuillez patienter...</div>
          </div>
        ) : (
          <Button
            type="primary"
            className="ajout-client-submit-button"
            onClick={submitHandler}
            disabled={loading}
          >
            تسجيل طلب حساب
          </Button>
        )}

        <div
          className="ajout-client-login-link"
          onClick={() => navigate("LoginClient")}
        >
          هل لديك حساب بالفعل؟تسجيل الدخول
        </div>
      </div>
    </div>
  );
};

export default AjoutClient;
